export default __webpack_public_path__ + "images/S7.bbfce3b.png";